import { useIsTaxConfirmationReviewer } from '~/composables/useIsTaxConfirmationReviewer';

export default defineNuxtRouteMiddleware(() => {
	if (useIsTaxConfirmationReviewer().value) {
		return;
	}

	return navigateTo('/');
});
